<h2 mat-dialog-title>
  Create Purchase Order
</h2>

<mat-dialog-content fxLayout="column">
  @if (isProcessing) {
    <busy-indicator page="true"></busy-indicator>
  }

  <mat-stepper #stepper [linear]="true">

    <mat-step [stepControl]="selectionForm">
      <ng-template matStepLabel>Requisition Selection</ng-template>
      <ng-template matStepContent>
        <form [formGroup]="selectionForm" fxLayout="column" fxLayoutAlign="stretch start">
          <lgd-checkbox controlName="allRequisitions" label="All Requisitions" aria-label="Select-AllRequisitions-RequisitionSelection-Purchasing-SelectAll">
          </lgd-checkbox>

          <div class="mt20 bold">Mass Selection</div>

          <lgd-typeahead fxFlexFill controlName="department" label="Department" (searchTextChanged)="lookupDepartments($event)" [options]="departmentsObservable" telemetry="Search-Department-RequisitionSelection-Purchasing">
          </lgd-typeahead>

          <div fxLayout="row" fxLayoutAlign="space-between start">
            <lgd-date-picker fxFlex="45" controlName="fromDate" label="From" telemetry="Search-FromDate-RequisitionSelection-Purchasing">s
            </lgd-date-picker>

            <lgd-date-picker fxFlex="45" controlName="toDate" label="To" telemetry="Search-ToDate-RequisitionSelection-Purchasing">
            </lgd-date-picker>
          </div>

          <div class="mt20 bold">Specific Selection</div>

          <div fxFlexFill fxLayout="row" fxLayoutAlign="space-between">
            <lgd-typeahead fxFlex="45" controlName="vendor" label="Vendor" (searchTextChanged)="lookupVendors($event)" [options]="vendorsObservable" telemetry="Search-Vendor-RequisitionSelection-Purchasing">
            </lgd-typeahead>

            <lgd-typeahead fxFlex="45" controlName="requisition" label="Requisition Number" (searchTextChanged)="lookupRequisitions($event)" [options]="requisitionsObservable" telemetry="Search-RequisitionNumber-RequisitionSelection-Purchasing">
            </lgd-typeahead>
          </div>
        </form>
      </ng-template>
    </mat-step>

    <mat-step [completed]="hasSelection">
      <ng-template matStepLabel>Review Selection</ng-template>
      <ng-template matStepContent>
        <requisition-selection-review [(issueDate)]="issueDate" [selectedRequisitions]="selectedRequisitions" [searchDepartment]="searchDepartment" [searchIssueDateFrom]="searchIssueDateFrom" [searchIssueDateTo]="searchIssueDateTo" [searchVendor]="searchVendor" [searchNumber]="searchNumber" (selectionChanged)="onSelectionChanged($event)">
        </requisition-selection-review>
      </ng-template>
    </mat-step>

    <mat-step>
      <ng-template matStepLabel>Send PO Notice Emails</ng-template>
      <ng-template matStepContent>
        <po-notice-emails [(emailBody)]="emailBody" [(emailSubject)]="emailSubject" [emails]="defaultEmailReqInfo" [requisitionIds]="selectedRequisitionIds" [(sendEmails)]="sendEmails">
        </po-notice-emails>
      </ng-template>
    </mat-step>
  </mat-stepper>
</mat-dialog-content>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="end start">
  <command-bar [commands]="commands"></command-bar>
</mat-dialog-actions>